// material-ui
import { Grid, Typography, Stack, Link } from '@mui/material';

// project imports
import MainCard from 'components/cards/MainCard';
import Main from 'views/layouts/Main/Main'; //
import {
	SimUnorderedList,
	SimSection,
	SimContactSupport,
	SimSectionHeader,
	StaticSectionWrapper
} from 'components/StaticSections';

const PatientRights = () => {
	return (
		<Main>
			<StaticSectionWrapper>
				<Grid container justifyContent='center' spacing={1}>
					<SimSectionHeader title='PATIENT RIGHTS' />
					<Grid item xs={12}>
						<MainCard elevation={4} border={false} boxShadow shadow={4} sx={{ mb: 3 }}>
							<Stack spacing={2} sx={{ textAlign: 'left' }}>
								<SimSection title='THIS POLICY DESCRIBES HOW TO COMPLAIN ABOUT MEDICAL TREATMENT AND SERVICES PROVIDED AND HOW TO FILE A GRIEVANCE. PLEASE REVIEW IT CAREFULLY.'>
									<Typography textAlign={'justify'}>
										SIM SOULS GROUP LLC’s and SIM SOULS INSTITUTE 1 INC’s (“SimSouls”, “we” or “us”)
										is committed to the quality and satisfaction of services provided for patients
										receiving medical treatment and services. We acknowledged that differences or
										disagreements may arise during the medical treatment process and wishes to
										resolve such instances in an expeditious and prudent manner for the benefit of
										the patient and their parents, legal guardians, or authorized representative
										(collectively the “representatives”).
									</Typography>
									<Typography textAlign={'justify'}>
										SIM SOULS GROUP LLC and SIM SOULS INSTITUTE 1 INC (“SimSouls”, “we” or “us”)
										affirms each patient’s right to receive care delivered in a considerate,
										respectful, dignified, and comforting manner. As a parent, guardian, or
										authorized representative of a patient at SIMSOULS, you have the right to
										receive information about your rights and the SIMSOULS’ policies related to
										those rights.
									</Typography>
								</SimSection>

								<SimSection title='I. AS PARENTS, YOU HAVE THE RIGHT TO:'>
									<SimUnorderedList
										list={[
											'Participate actively in decisions about your child’s medical care.',
											'Expect a reasonable response to any reasonable request for service within the capacity of SIMSOULS, its stated mission and the law.',
											'Know the names of the physicians, nurses and other healthcare providers who care for your child.',
											'Retain privacy and confidential treatment of all communications and records pertaining to your child’s care, within the limits of the law.',
											'Be told by a physician, in words or a language you understand, about illness, treatment and prospects for recovery.',
											'Receive as much information as you may need to give or refuse consent for any proposed treatment.',
											'Make decisions, in consultation with our child’s doctor, about your child’s healthcare. This includes the right to accept or refuse medical care for your child as allowed by law and to be told of the medical consequences of such refusal.',
											'Complete an advance directive (for example, a “living will”) for your child as allowed by law and to expect your child’s healthcare providers to comply with any such directive.',
											'Expect proper management of your child’s pain.',
											'Participate in ethical issues about your child’s care.',
											'Use the telephone to make and receive calls and to know that any restrictions for medical reasons will be discussed with you.',
											'Access your child’s medical records within a reasonable time frame.',
											'Have a family member or representative of your choice and your child’s physician informed of your child’s admission.',
											'Have your child treated with comfort and dignity if your child is dying. This includes managing your child’s pain, treating symptoms that respond to treatment and recognizing the cultural, spiritual and grief needs of you, your child, and your family.',
											'Receive care that is free from harassment or abuse from anyone.',
											'Have your child free from physical or medical restraints that are not medically necessary.',
											'Have your child be free from restraints or seclusion for behavior management unless it is an emergency.',
											'Receive care in a safe setting.',
											'Be treated considerately and respectfully without regard to race, color, national origin, sex, religion, gender identity, sexual orientation, disability, or cultural, economic, or educational background.',
											'Refuse to participate in any research project affecting your child’s care and treatment.',
											'Be free to lodge a complaint and receive feedback.',
											'Have help in contacting protective services when needed.',
											'Be told whatever is needed to understand why you are here.',
											'Be told exactly what will be done and exactly what it will feel like.',
											'Be given understandable answers to any questions or worries you have about treatment.',
											'Tell everyone what you think and feel about your treatment and what is planned for you.',
											'Know that when you are in pain people taking care of you will listen to you and help you feel better.',
											'Have time and places to play and learn.',
											'Be told by people who need to touch your body exactly what they will do and that they will do it in a gentle and private way.',
											'Have your family with you as much as you want, whenever possible.',
											'Have help to know how to take care of yourself when you go home.',
											'Get angry, cry, or say what you don’t like about what is happening to you.',
											'Receive visitors whom the parent designates. The parents can withdraw or deny this designation at any time.'
										]}
									/>
								</SimSection>

								<SimSection title='II. AS PATIENTS AND PARENTS, YOU HAVE THE RESPONSIBILITY TO:'>
									<SimUnorderedList
										list={[
											'Ask questions when you do not understand what you have been told about care.',
											'Provide accurate and complete information about matters relating to the patient’s health.',
											'Follow the treatment plan mutually agreed upon by you and your healthcare team.',
											'Talk to your doctor about what you expect regarding pain and pain management.',
											'Be considerate of other patients.',
											'Follow the SIMSOULS’ rules and regulations.',
											'Report perceived risks with care and unexpected changes in the patient’s condition.'
										]}
									/>
								</SimSection>

								<SimSection title='III. HOW TO COMPLAIN ABOUT MEDICAL TREATMENT AND SERVICES'>
									<SimUnorderedList
										title='We encourage you to talk with:'
										list={[
											'Your child’s therapist or BCBA.',
											'The BCBA or clinical director.',
											'The guest relations representative at the Care Line +1.469.269.0515.'
										]}
									/>
									<Typography>
										If you or your family feel your rights as a patient were not upheld, you have
										the right to file a grievance and receive a written response from the Grievance
										Resolutions Committee of SIMSOULS or file a grievance with one of the agencies
										below.
									</Typography>
									<Typography>
										If you feel your issues are not being resolved or addressed by SIMSOULS, you may
										contact:
									</Typography>
									<SimSection title='THE JOINT COMMISSION OFFICE OF QUALITY AND PATIENT SAFETY'>
										<SimUnorderedList
											title='Patient safety concerns can be reported to The Joint Commission:'
											list={[
												'By calling 800-994-6610 to receive an automated message providing instructions on how to file a written patient safety report or concern.',
												'At www.jointcommission.org, using the “Report a Patient Safety Event” link in the “Action Center” on the home page of the website.',
												'By fax to 630-792-5636.',
												'By mail to Office of Quality and Patient Safety, The Joint Commission, One Renaissance Boulevard, Oakbrook Terrace, IL 60181.'
											]}
										/>
									</SimSection>
									<SimSection title='HEALTH FACILITY COMPLIANCE GROUP'>
										<Typography textAlign='justify'>
											Texas Department of State Health Services <br />
											P.O. Box 149347, Austin, Texas 78714
											<br />
											hfc.complaints@dshs.state.tx.us | 1-888-973-0022 Complaint Hotline |
											1-512-834-6653 Fax
										</Typography>
									</SimSection>
								</SimSection>

								<SimSection title='IV. CHANGES TO THIS POLICY'>
									<Typography textAlign='justify'>
										The Company may change the Terms from time to time as required by evolving
										business needs. If changes are made, please note that it may take up to 30
										business days before new practices are implemented. The current revision date
										will always be designated within the Terms. Check this page periodically if you
										would like to monitor changes. You are responsible for periodically visiting our
										Website and this Policy to check for any changes.
									</Typography>
								</SimSection>

								<SimSection title='V. CONTACT INFORMATION'>
									<Typography textAlign='justify'>
										If you have any questions, comments or concerns about this policy or your
										interactions with SIMSOULS, please email us at{' '}
										<Link href='#' underline='none'>
											compliance@simsouls.com
										</Link>{' '}
										or call us at +1.469.269.0515.
									</Typography>
								</SimSection>

								<SimSection title='VI. EFFECTIVE DATE'>
									<Typography textAlign='justify'>
										This Policy was effective on 06/20/2022.
									</Typography>
								</SimSection>
							</Stack>
						</MainCard>
					</Grid>
				</Grid>
			</StaticSectionWrapper>
		</Main>
	);
};

export default PatientRights;
